import React from 'react';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import amplitude from 'amplitude-js';
import { toggleSpinner } from 'apps/auth/actions/appAction';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper, PanelFrame, PanelRow } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import { INCREASE_LIMITS_DOCUMENTS_SELECTED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { DOCUMENT_TYPE } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { LIECHTENSTEIN, UK } from 'apps/auth/constants/WellKnownCountries';

const OnfidoDoc = ({ userType = 'ga', ...props }) => {
    const [searchParams] = useSearchParams();
    const addParamToUrl = searchParams ? '?' + searchParams : '';

    let flagName = props.flagName;
    let secondFlagName = null;
    if (props.type === 'driving_licence') {
        if (props.userCountryId === UK) {
            flagName = 'gb';
            secondFlagName = 'eu';
        } else if (props.userCountryInEEA || props.userCountryId === LIECHTENSTEIN) {
            flagName = 'eu';
        }
    } else if (props.type === 'residence_permit') {
        if (props.userCountryId === UK) {
            flagName = 'gb';
        } else if (props.userCountryInEEA || props.userCountryId === LIECHTENSTEIN) {
            flagName = 'eu';
        }
    } else if (props.type === 'national_identity_card') {
        if (props.userCountryId === UK || props.userCountryInEEA || props.userCountryId === LIECHTENSTEIN) {
            flagName = 'eu';
        }
    }

    return (
        <Row indent="adaptive-32-48">
            <Panel
                type="link"
                href={`/auth/kyc/${userType}/onfido/frame/${props.type}` + addParamToUrl}
                onClick={(e) => {
                    if (props.onClick) {
                        e.preventDefault();
                        props.onClick(props.type);
                    } else {
                        amplitude.getInstance().logEvent(INCREASE_LIMITS_DOCUMENTS_SELECTED, { [DOCUMENT_TYPE]: props.type });
                        props.toggleSpinner(true);
                    }
                }}
                isBordered
                hasBorderRadius
            >
                <PanelFrame>
                    <DiskBadgeWrapper>
                        <DiskBadge
                            iconName={props.type === 'passport' ? 'passport' : 'id-card'}
                            variant="secondary"
                            flagName={flagName}
                            secondFlagName={secondFlagName}
                        />
                    </DiskBadgeWrapper>
                    <div>
                        <PanelRow>
                            <Text datatype={props.type}>{props.title}</Text>
                        </PanelRow>
                        {props.subTitle && (
                            <PanelRow>
                                <Text size="secondary" color="secondary">
                                    {props.subTitle}
                                </Text>
                            </PanelRow>
                        )}
                    </div>
                </PanelFrame>
            </Panel>
        </Row>
    );
};

export default connect(
    () => {
        return {};
    },
    { toggleSpinner },
)(OnfidoDoc);
